(() => {
  "use strict";

  const init = (root = document) => {
    root.querySelectorAll("[data-hemp-product]").forEach(section => {
      if (section.dataset.initialized === "true") return;
      section.dataset.initialized = "true";

      const variants = JSON.parse(section.querySelector("[data-product-variants]")?.textContent || "[]");
      const optionInputs = [...section.querySelectorAll("[data-option-value]")];
      const variantInput = section.querySelector("[data-variant-id]");
      const price = section.querySelector("[data-current-price]");
      const compare = section.querySelector("[data-compare-price]");
      const addButton = section.querySelector("[data-add-to-cart]");
      const addText = section.querySelector("[data-add-to-cart-text]");
      const quantity = section.querySelector("[data-quantity-input]");
      const slides = [...section.querySelectorAll("[data-gallery-slide]")];
      const thumbs = [...section.querySelectorAll("[data-gallery-thumbnail]")];
      let slideIndex = Math.max(0, slides.findIndex(s => s.classList.contains("is-active")));

      const formatMoney = cents => {
        const amount = Number(cents || 0) / 100;
        const currency = window.Shopify?.currency?.active || "USD";
        return new Intl.NumberFormat(document.documentElement.lang || "en", {
          style: "currency",
          currency
        }).format(amount);
      };

      const showMedia = id => {
        slides.forEach((slide, index) => {
          const active = String(slide.dataset.mediaId) === String(id);
          slide.hidden = !active;
          slide.classList.toggle("is-active", active);
          if (active) slideIndex = index;
        });
        thumbs.forEach(thumb => thumb.classList.toggle("is-active", String(thumb.dataset.mediaId) === String(id)));
      };

      thumbs.forEach(thumb => thumb.addEventListener("click", () => showMedia(thumb.dataset.mediaId)));

      section.querySelector("[data-gallery-previous]")?.addEventListener("click", () => {
        if (!slides.length) return;
        slideIndex = (slideIndex - 1 + slides.length) % slides.length;
        showMedia(slides[slideIndex].dataset.mediaId);
      });

      section.querySelector("[data-gallery-next]")?.addEventListener("click", () => {
        if (!slides.length) return;
        slideIndex = (slideIndex + 1) % slides.length;
        showMedia(slides[slideIndex].dataset.mediaId);
      });

      const updateVariant = () => {
        const selected = [...section.querySelectorAll("[data-product-option]")].map(group => group.querySelector("[data-option-value]:checked")?.value);
        const variant = variants.find(v => v.options.every((value, index) => value === selected[index]));

        if (!variant) {
          if (variantInput) variantInput.value = "";
          if (addButton) addButton.disabled = true;
          if (addText) addText.textContent = "UNAVAILABLE";
          return;
        }

        variantInput.value = variant.id;
        price.textContent = formatMoney(variant.price);

        if (compare) {
          const show = Number(variant.compare_at_price) > Number(variant.price);
          compare.hidden = !show;
          compare.textContent = show ? formatMoney(variant.compare_at_price) : "";
        }

        addButton.disabled = !variant.available;
        addText.textContent = variant.available ? "ADD TO CART" : "SOLD OUT";

        if (variant.featured_media?.id) showMedia(variant.featured_media.id);

        const url = new URL(window.location.href);
        url.searchParams.set("variant", variant.id);
        history.replaceState({}, "", url);
      };

      optionInputs.forEach(input => input.addEventListener("change", updateVariant));

      section.querySelector("[data-quantity-decrease]")?.addEventListener("click", () => {
        quantity.value = Math.max(1, Number(quantity.value || 1) - 1);
      });

      section.querySelector("[data-quantity-increase]")?.addEventListener("click", () => {
        quantity.value = Math.max(1, Number(quantity.value || 1) + 1);
      });

      const tabButtons = [...section.querySelectorAll("[data-tab-button]")];
      const tabPanels = [...section.querySelectorAll("[data-tab-panel]")];

      tabButtons.forEach(button => button.addEventListener("click", () => {
        const name = button.dataset.tabButton;
        tabButtons.forEach(b => b.classList.toggle("is-active", b === button));
        tabPanels.forEach(panel => {
          const active = panel.dataset.tabPanel === name;
          panel.hidden = !active;
          panel.classList.toggle("is-active", active);
        });
      }));
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => init());
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", event => init(event.target));
})();